import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet } from 'APIPackage/MainModule/common/apiTools';

import { IProsecutorOrganizations } from '../interfaces/IProsecutorOrganizations';

export async function fetchProsecutorOrganizationsApi(): Promise<IProsecutorOrganizations[]> {
  return apiGet<IProsecutorOrganizations[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/ervk/prosecutor-organizations`,
  );
}
